<template>
  <div class="container" >
    <el-divider content-position="left">过程考核参数配置</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.checkin_id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入考核类型"
        size="mini"
        clearable
        :remote-method="searchRemoteCheckIn"
        :loading="searchLoading"
        @change="handleSearchCheckInSetting"
      >
        <el-option
          v-for="searchCheckItem in searchCheckSetting"
          :key="searchCheckItem.id"
          :label="searchCheckItem.process_check_name"
          :value="searchCheckItem.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="small" @click="checkIn"
          >录入</el-button
        >
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </div>
    </div>
    
    <el-drawer
      title="录入"
      :visible.sync="checkIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="checkInForm"
          ref="checkInForm"
          label-width="100px"
        >
          <el-form-item label="所属配置">
            <el-radio-group v-model="checkInForm.type" size="mini">
              <el-radio :label="1" border>过程考核类型配置</el-radio>
              <el-radio :label="2" border>沟通方式配置</el-radio>
              <el-radio :label="3" border>沟通关键词配置</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="类型名称">
            <el-input v-model="checkInForm.check_name" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input v-model="checkInForm.sort" type="number" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="关键词分类" v-show="checkInForm.type === 1">
            <el-checkbox-group v-model="checkInForm.sub_keyword_cates">
              <el-checkbox v-for="item in keywordsCates" :label="item.id" :key="item.id">{{ item.process_check_name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>


          <el-form-item label="关键词" v-show="checkInForm.type === 3">
            <el-input type="textarea" size="mini" v-model="checkInForm.keyword"
              placeholder="请填写关键词，例：下单｜付款｜合同｜发票" style="white-space: pre"></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>

    <el-drawer
      title="修改"
      :visible.sync="checkInEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="editcheckInForm"
          ref="editcheckInForm"
          label-width="100px"
        >
          <el-form-item label="类型名称" prop="">
            <el-input
              v-model="editcheckInForm.check_name"
              size="mini"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序值">
            <el-input v-model="editcheckInForm.sort" type="number" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="关键词分类" v-show="editcheckInForm.type === 1">
            <el-checkbox-group v-model="editcheckInForm.sub_keyword_cates">
              <el-checkbox v-for="item in keywordsCates" :label="item.id" :key="item.id">{{ item.process_check_name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>


          <el-form-item label="关键词" v-show="editcheckInForm.type === 3">
            <el-input type="textarea" size="mini" v-model="editcheckInForm.keyword"
              placeholder="请填写关键词，例：下单｜付款｜合同｜发票" style="white-space: pre"></el-input>
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 已完成订单模块 开始-->
      <el-tab-pane label="过程考核类型配置" name="1">
        <el-table
          max-height="650"
          :data="checkInSetting"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="ID" width="60"></el-table-column>

          <el-table-column label="类型名称" width="100">
            <template slot-scope="scope">
              <el-tooltip content="双击修改" placement="top" v-if="!needEditStatus[scope.row.id]">
                <span class="hide-style" @dblclick="toEdit(scope.row.process_check_name, scope.row.id)">{{ scope.row.process_check_name }}</span>
              </el-tooltip>
              <edit-input v-if="needEditStatus[scope.row.id] === true" :name="updateName" :id="updateId" @updatePrice="doUpdatePrice" @revert="revert" />
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序" width="80">
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="listSort[scope.row.id]"
                @blur="setSort(scope.row)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="创建时间" width="100"></el-table-column>
        
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top">
                <el-button
                  @click.native.prevent="editRow(scope.$index, scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="沟通方式配置" name="2">
        <el-table
          max-height="650"
          :data="checkInSetting"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="ID" width="60"></el-table-column>


          <el-table-column label="类型名称" width="100">
            <template slot-scope="scope">
              <el-tooltip content="双击修改" placement="top" v-if="!needEditStatus[scope.row.id]">
                <span class="hide-style" @dblclick="toEdit(scope.row.process_check_name, scope.row.id)">{{ scope.row.process_check_name }}</span>
              </el-tooltip>
              <edit-input v-if="needEditStatus[scope.row.id] === true" :name="updateName" :id="updateId" @updatePrice="doUpdatePrice" @revert="revert" />
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序" width="80">
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="listSort[scope.row.id]"
                @blur="setSort(scope.row)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="创建时间" width="100"></el-table-column>
        
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top">
                <el-button
                  @click.native.prevent="editRow(scope.$index, scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="沟通关键词配置" name="3">
        <el-table
          max-height="650"
          :data="checkInSetting"
          style="width: 100%; margin-top: 10px"
          border
          size="mini"
          :header-cell-style="{
            background: '#ecf4ff',
            color: '#333',
            fontWeight: '900',
            fontSize: '0.28rem',
          }"
        >
          <el-table-column prop="id" label="ID" width="60"></el-table-column>

          <el-table-column label="类型名称" width="100">
            <template slot-scope="scope">
              <el-tooltip content="双击修改" placement="top" v-if="!needEditStatus[scope.row.id]">
                <span class="hide-style" @dblclick="toEdit(scope.row.process_check_name, scope.row.id)">{{ scope.row.process_check_name }}</span>
              </el-tooltip>
              <edit-input v-if="needEditStatus[scope.row.id] === true" :name="updateName" :id="updateId" @updatePrice="doUpdatePrice" @revert="revert" />
            </template>
          </el-table-column>

          <el-table-column prop="sort" label="排序" width="80">
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="listSort[scope.row.id]"
                @blur="setSort(scope.row)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="created_at" label="创建时间" width="100"></el-table-column>
        
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top">
                <el-button
                  @click.native.prevent="editRow(scope.$index, scope.row)"
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                >
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

    </el-tabs>
    
    

    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="checkInPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import EditInput from './components/EditInput'
export default {
  name: 'ProcessCheck',
  components: {
    EditInput
  },
  data () {
    return {

      searchArr: {
        checkin_id: '',
        type: 1
      },
      needEditStatus: [],
      updateName: '',
      updateId: null,
      npage: 1,
      checkInPerPage: 10,
      total: null,
      checkInSetting: [],
      direction: 'rtl',
      searcher: null,
      searchLoading: false,
      searchCheckSetting: [],
      activeName: '1',
      checkIndrawer: false,
      checkInEditDrawer: false,
      listSort: [],
      checkInForm: {
        check_name: '',
        type: null,
        sort: 0,
        keyword: '',
        sub_keyword_cates: []
      },
      editcheckInForm: {
        id: null,
        check_name: '',
        type: null,
        sort: 0,
        keyword: '',
        sub_keyword_cates: []
      },
      keywordsCates: []
    }
  },
  mounted () {
    this.loadTable()
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    },
  },
  methods: {
    loadTable () {
      this.$axios
        .get('api/admin/process/check/get_check_setting', {
          params: {
            page: this.npage,
            perpage: this.checkInPerPage,
            searchItem: this.searcher,
            type: this.searchArr.type
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.checkInSetting = data.data.data
            this.keywordsCates = data.keywordsCates
            this.total = data.data.total
            this.loadSort()
          }
        })
        .catch()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.checkInPerPage = val
      this.loadTable()
    },
    checkIn () {
      this.checkIndrawer = true
    },
    submitForm () {
      if (this.checkInForm.type === null) {
        this.$message.error('请选择所属配置!')
        return false
      }
      if (!this.checkInForm.check_name) {
        this.$message.error('请填写类型名称!')
        return false
      }
      if (this.checkInForm.type === 3 && this.checkInForm.keyword === '') {
        this.$message.error('该类型配置下，关键词必须填写!')
        return false
      }
      if (this.checkInForm.type === 1 && this.checkInForm.sub_keyword_cates.length <= 0) {
        this.$message.error('该类型配置下，关键词分类必须选择!')
        return false
      }
      this.$axios
        .post('api/admin/process/check/store', {
          check_data: this.checkInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkIndrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editSubmitForm () {
      this.$axios
        .post('api/admin/process/check/edit_store', {
          check_setting: this.editcheckInForm
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.checkInEditDrawer = false
            this.loadTable()
            this.resetForm()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    editRow (index, row) {
      this.editcheckInForm.id = row.id
      this.editcheckInForm.check_name = row.process_check_name
      this.editcheckInForm.type = row.type
      this.editcheckInForm.sort = row.sort
      this.editcheckInForm.keyword = row.keyword
      if (row.sub_ids) {
        const subIdsArray = row.sub_ids.split(",").map(Number);
        this.editcheckInForm.sub_keyword_cates = Array.isArray(subIdsArray) ? subIdsArray : [];
      } else {
        this.editcheckInForm.sub_keyword_cates = [];
      }
      this.checkInEditDrawer = true
    },
    loadSort () {
      this.checkInSetting.map(item => {
        this.listSort[item.id] = Number(item.sort)
      })
    },
    setSort (row) {
      if (isNaN(this.listSort[row.id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .post('api/admin/process/check/set_sort', {
          id: row.id,
          sort: this.listSort[row.id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.loadTable()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    searchRemoteCheckIn (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCheckSetting = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/admin/process/check/check_item_search', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.searchCheckSetting = data.data
          }
        })
        .catch()
    },
    handleSearchCheckInSetting (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          this.resetForm()
          done()
        })
        .catch(_ => {})
    },
    toEdit(name, id) {
      this.updateId = null
      this.updateName = ''
      this.needEditStatus = []
      this.needEditStatus.push(id)
      this.needEditStatus[id] = true
      this.$nextTick(() => {
        this.updateName = name
        this.updateId = id
      })
    },
    revert() {
      this.needEditStatus = []
      this.loadTable()
    },
    doUpdatePrice() {
      this.needEditStatus = []
      // this.loadTable()
    },
    resetForm () {
      // 添加
      this.checkInForm.check_name = ''
      this.checkInForm.type = null
      this.checkInForm.sort = 0
      this.checkInForm.keyword = ''
      this.checkInForm.sub_keyword_cates = []
      // 编辑
      this.editcheckInForm.id = null
      this.editcheckInForm.check_name = ''
      this.editcheckInForm.type = null
      this.editcheckInForm.sort = 0
      this.editcheckInForm.keyword = ''
      this.editcheckInForm.sub_keyword_cates = []
    },
    // 选项卡默认点击事件
    handleClick (tab, event) {
      // 监听点击事件
      if (parseInt(tab.index) === 0) {
        this.searchArr.type = '1'
        this.npage = 1
        this.loadTable()
      } else if (parseInt(tab.index) === 1) {
        this.searchArr.type = '2'
        this.npage = 1
        this.loadTable()
      } else if (parseInt(tab.index) === 2) {
        this.searchArr.type = '3'
        this.npage = 1
        this.loadTable()
      }
    },
  }
}
</script>

<style  scoped>
.container {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/ProcessCheck.vue